import { BigNumber } from '@ethersproject/bignumber';

import { bn, convertBnToDecimals, divideBignumbers } from 'tools/math';

const calculateDepositAmountsEqually = (
  total: BigNumber,
  balances: { address: string; balance: BigNumber }[],
  decimal: number,
) => {
  const balancesLength = balances.length;

  const dividedBalance = convertBnToDecimals(
    divideBignumbers([total, decimal], [bn(balancesLength), 18]),
    18,
    decimal,
  );

  const withdrawWalletBalances = {} as Record<string, BigNumber>;
  for (const wallet of balances) {
    withdrawWalletBalances[wallet.address] = dividedBalance;
  }

  return withdrawWalletBalances;
};

const calculateDepositAmountsByRandPercent = (
  total: BigNumber,
  balances: { address: string; balance: BigNumber }[],
  decimal: number,
  randPercent: string,
) => {
  const balancesLength = balances.length;

  const percentValue = parseFloat(randPercent) / 100;
  const minFactor = 1 - percentValue;
  const maxFactor = 1 + percentValue;

  const adjustedBalances: BigNumber[] = [];
  let sumAdjusted = bn(0);

  for (const _ of balances) {
    const randomFactor = Math.random() * (maxFactor - minFactor) + minFactor;

    const adjustedBalance = convertBnToDecimals(
      divideBignumbers([total, decimal], [bn(balancesLength), 18])
        .mul(bn(Math.round(randomFactor * 10000)))
        .div(bn(10000)),
      18,
      decimal,
    );

    adjustedBalances.push(adjustedBalance);
    sumAdjusted = sumAdjusted.add(adjustedBalance);
  }

  const difference = total.sub(sumAdjusted);
  adjustedBalances[0] = adjustedBalances[0].add(difference);

  const withdrawWalletBalances: Record<string, BigNumber> = {};

  balances.forEach((wallet, index) => {
    withdrawWalletBalances[wallet.address] = adjustedBalances[index];
  });

  return withdrawWalletBalances;
};

export const calculateDepositAmounts = (
  total: BigNumber,
  balances: { address: string; balance: BigNumber }[],
  decimal: number,
  randPercent?: string,
) =>
  randPercent
    ? calculateDepositAmountsByRandPercent(total, balances, decimal, randPercent)
    : calculateDepositAmountsEqually(total, balances, decimal);
